"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.7 20.6",
    width: "58.7",
    height: "20.6"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M58.2,16.5H53c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h4.7V1H1v12.5l6.9,2h21.4c0.3,0,0.5,0.2,0.5,0.5 s-0.2,0.5-0.5,0.5H7.8c0,0-0.1,0-0.1,0l-7.3-2.1C0.1,14.3,0,14.1,0,13.9V0.5C0,0.2,0.2,0,0.5,0h57.7c0.3,0,0.5,0.2,0.5,0.5V16 C58.7,16.3,58.5,16.5,58.2,16.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M3.8,20c-0.3,0-0.5-0.2-0.5-0.5v-4c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v4C4.3,19.8,4.1,20,3.8,20z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M41.1,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C44.3,19.1,42.9,20.6,41.1,20.6z M41.1,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S42.3,15.2,41.1,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M48.6,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2s3.2,1.4,3.2,3.2C51.8,19.1,50.4,20.6,48.6,20.6z M48.6,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2s2.2-1,2.2-2.2S49.8,15.2,48.6,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M33.6,20.6c-1.8,0-3.2-1.4-3.2-3.2c0-1.8,1.4-3.2,3.2-3.2c1.8,0,3.2,1.4,3.2,3.2 C36.8,19.1,35.3,20.6,33.6,20.6z M33.6,15.2c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2c1.2,0,2.2-1,2.2-2.2S34.8,15.2,33.6,15.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M7.8,16c-0.3,0-0.5-0.2-0.5-0.5v-15C7.3,0.2,7.6,0,7.8,0s0.5,0.2,0.5,0.5v15C8.3,15.8,8.1,16,7.8,16z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M15.8,16c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C16.3,15.8,16.1,16,15.8,16 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M54.8,16c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C55.3,15.8,55.1,16,54.8,16 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23.8,16c-0.3,0-0.5-0.2-0.5-0.5v-15c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v15C24.3,15.8,24.1,16,23.8,16 z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "40.8",
    cy: "8.1",
    r: "4.7"
  }));
};

exports["default"] = _default;